import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { RootState } from "../../redux/store";

const CustomerAuthRoute: React.FC = () => {
  const location = useLocation();

  const customer = useSelector((state: RootState) => state.auth.customer);

  const isRegisteredCustomer =
    customer.isLoggedIn && customer.customerType === "registered";

  if (!isRegisteredCustomer) {
    return (
      <Navigate
        to="/"
        replace
        state={{
          from: location.pathname,
          requiresLogin: true,
        }}
      />
    );
  }

  return <Outlet />;
};

export default CustomerAuthRoute;
